<ul class="progress-indicator">
  <li *ngFor="let i of totalSteps | times"
      [class.completed]="currentStep >= i"
      [class.last]="currentStep === i">
    <span class="bubble"></span>
    <span [hidden]="!showNumbers">{{i + '/' + totalSteps}}</span>
  </li>
</ul>
